<template>
    <div class="modal is-active">
        <div class="modal-background" @click="toggleModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ $t('attributes.title') }}</p>
                <button class="delete" @click.prevent="toggleModal"></button>
            </header>
            <section class="modal-card-body">
                <template v-for="category in allAttributes">
                    <div
                        :key="category.id"
                        v-if="category.attributes && category.attributes.length > 0"
                        class="category"
                    >
                        <h3>{{ category.name }}</h3>
                        <ul class="attribute-wrapper columns is-multiline">
                            <template v-for="attribute in category.attributes">
                                <li
                                    :key="attribute.id"
                                    class="attribute column is-half"
                                    v-if="showAttribute(attribute)"
                                >
                                    <label class="checkbox">
                                        <input
                                            class="edit-box__inline-input"
                                            type="checkbox"
                                            :value="attribute.id"
                                            v-model="attributes"
                                        />
                                        {{ attribute.name }}
                                    </label>
                                </li>
                            </template>
                        </ul>
                    </div>
                </template>
            </section>
            <footer class="modal-card-foot is-clearfix">
                <a class="button is-primary" @click="saveAttributes">{{ $t('generic.save') }}</a>
                <a class="button" @click="toggleModal">{{ $t('generic.cancel') }}</a>
            </footer>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'attributes',
        props: {
            allAttributes: {
                type: Array,
                default: () => [],
            },
            activeAttributes: {
                type: Array,
                default: () => [],
            },
            accommodationType: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                attributes: [],
            };
        },
        created() {
            this.attributes = this.activeAttributes.map((attribute) => attribute.id);
        },
        methods: {
            toggleModal() {
                this.$emit('toggle-modal');
            },
            saveAttributes() {
                this.$emit('save', this.attributes);
            },
            showAttribute(attribute) {
                if(this.accommodationType === '') {
                    return true;
                }

                if(this.accommodationType === 'accomodation') {
                    return attribute.valid_for_rentals;
                }

                return attribute.valid_for_pitches;
            },
        }
    };
</script>

<style lang="scss" scoped>
.modal-card {
    width: 80%;
    max-width: 800px;
}

.category {
    margin-top: 1.5rem;
}

.attribute {
    padding: 0.25rem 0;
}

.attribute-wrapper {
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/components/attributes/index.vue